
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">Daily Leave Details</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Start Date </label>
          <input disabled type="text" value="{{startDate_fulldate}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> End Date </label>
          <input disabled type="text" value="{{endDate_fulldate}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Substitute </label>
          <input disabled type="text" value="{{replace_person}}" class="form-control" placeholder="Type here...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Working Day </label>
          <input disabled type="text" value="{{on}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Holiday </label>
          <input disabled type="text" value="{{off}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input disabled type="text" value="{{dsc}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
    </form>
  </div>
</div>